<template>
  <div class="c-light-box-body">
    <div class="c-light-box-body__inner">
      <light-box-cross />
      <slot> </slot>
    </div>
  </div>
</template>

<script>
import LightBoxCross from "components/LightBox/LightBoxCross";
export default {
  components: {
    LightBoxCross
  }
};
</script>

<style lang="scss" scoped>
.c-light-box-body {
  @include sectionColouredPadding;

  display: flex;
  height: 100vh;
  width: 100vw;

  &__inner {
    height: 100%;
    display: flex;
    flex: 1;
    justify-items: center;
    align-content: center;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }
}
</style>
